import React from "react";

import { getImage, ImageType } from "../../../../helpers/imageHelper";
import { useStrings } from "../../../../localization/localizationHelpers";

import { LandingCtaPlacements, useLandingCta } from "../../useLandingCta";
import * as styles from "./PartnerFinalCtaSection.module.css";

const gameImages = [
  { name: "landing_floating_game1", className: styles.game1 },
  { name: "landing_floating_game2", className: styles.game2 },
  { name: "landing_floating_game3", className: styles.game3 },
  { name: "landing_floating_game4", className: styles.game4 },
];

export const PartnerFinalCtaSection = () => {
  const handleGetStarted = useLandingCta(LandingCtaPlacements.final);

  const [title, description, buttonLabel] = useStrings(
    "landingFinalTitle",
    "landingFinalDescription",
    "landingHeroGetStartedButton"
  );

  return (
    <section className={styles.section}>
      {gameImages.map(game => (
        <img
          key={game.name}
          className={`${styles.gameIcon} ${game.className}`}
          src={getImage(game.name, ImageType.Png)}
          alt=""
          aria-hidden="true"
        />
      ))}
      <div className={styles.content}>
        <h2 className={styles.title}>{title}</h2>
        <p className={styles.description}>{description}</p>
        <button className={styles.getStartedButton} onClick={handleGetStarted}>
          {buttonLabel}
        </button>
      </div>
    </section>
  );
};
